import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import Grid from "@mui/material/Grid";



const CheckSocetPage = ({ socetInfo, onStateChange }) => {
    
   // const {socetInfo} = props;

    console.log('socetInfo', socetInfo);
    console.log('socetInfo',  ['null', '', null, undefined].includes(socetInfo.err));
   

    function nextButtonClick(){
        
        onStateChange(true); // Вызываем функцию обратного вызова
    }

    
    return (
        <div  >
        <h2>{}Проверка соединения с сигнальным сервером</h2>
  
          <br/>
          <p style={{color: 'red'}}>
          {socetInfo.err ===null ? '': socetInfo.err}
          </p>
  
        <div style={{display: 'flex',  textAlign: 'center', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>

       
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
          <Grid item sx={{color:'gray'}}>{'Статус соединения:'}</Grid>
          <Grid item >{
            socetInfo.conected === true ? 
            <p style={{color: 'green'}}>Успешно соединен</p>
            : 

            <p style={{color: 'red'}}>Соединение отсутствует</p>
          }</Grid>
        </Grid>
   
        {
            socetInfo.conected===true && ['null', '', null, undefined].includes(socetInfo.err)===true ? 
            <>
            <br/>    <br/> 
            <Button  
            onClick={nextButtonClick}
            variant="contained"  sx={{ borderRadius: '16px',  background: 'green', minWidth: '150px'}}>
                Далее
            </Button>
            </>
       
            : <></>

        }
         </div>
        
      </div>
    );
  };


  export default CheckSocetPage;
